// extracted by mini-css-extract-plugin
export default {"cardsContainer":"Cards_cardsContainer__tCNaC","spinner":"Cards_spinner__41cNZ","loadMore":"Cards_loadMore__xWJ0s"};